// Hardcoded OSS numbers, refreshed by hand from pypistats.org before an
// application cycle. Deliberately NOT fetched at build time: "+15k" rounding
// makes staleness harmless, and network-dependent builds mean flaky CI plus
// nondeterministic PDF artifacts.

export interface OpenSourceProject {
    name: string
    pitch: string
    monthlyDownloads: string
    stars?: string
    href: string
}

export const OPEN_SOURCE_PROJECTS: OpenSourceProject[] = [
    {
        name: "bakefile",
        pitch: "OOP Python task runner; write tasks once, reuse everywhere",
        monthlyDownloads: "15k+ downloads/month",
        href: "https://bakefile.wisl.dev",
    },
    {
        name: "zerv",
        pitch: "Rust CLI for git-based versioning; SemVer/PEP 440/CalVer, CI/CD ready",
        monthlyDownloads: "15k+ downloads/month",
        href: "https://zerv.wisl.dev",
    },
    {
        name: "leetcode-py",
        pitch: "LeetCode practice environment generator",
        monthlyDownloads: "8k+ downloads/month",
        stars: "140 stars",
        href: "https://leetcode-py.wisl.dev",
    },
]
